module.exports = __webpack_public_path__ + "img/jrc.46b27edd.png";